import jwt from "jwt-decode";
import { ROLE_IDS, subTab, tab } from "../constants/tabs";
import { Privileges } from "../enums/privilege.enum";
import { RoleId } from "../enums/role-id.enum";
export default function roleAndPrivilegesFnc(token) {
  let userData = jwt(token, { alg: "HS256" });
  let roleData = userData?.data?.role;
  let roleId = userData?.data?.roleId;
  let userInfo = userData?.data;
  const id = userData?.data?.id;
  const groupId = userData?.data?.groupId;
  const userName = {
    firstName: userData?.data?.firstName,
    lastName: userData?.data?.lastName,
  };
  const npi = userData?.data?.npi;

  const tempPassword = userData?.data?.tempPassword;

  const isSuperAdmin = roleId === RoleId.SuperAdmin;

  const isAdministrator = roleId === RoleId.Administrator;

  const isInsuranceDepartment = roleId === RoleId.InsuranceDepartment;

  userData = userData?.data?.priveleges?.split(",");
  let trimmedUserData = userData?.map((element) => {
    return element.trim();
  });

  let isOrderAuthority = 0;
  if (userData?.includes(" orderAuthority")) {
    isOrderAuthority = 1;
  }

  let isEncryptedInfo = 0;
  if (userData?.includes(" encryptedInfo")) {
    isEncryptedInfo = 1;
  }

  let isAllPatients = 0;
  if (userData?.includes(" allPatients")) {
    isAllPatients = 1;
  }

  let isPhysician = 0;
  if (roleId === ROLE_IDS?.PHYSICIAN) {
    isPhysician = 1;
  }

  let isDiscussResults = 0;
  if (userData?.includes(" discussResults")) {
    isDiscussResults = 1;
  }

  let isReviewResults = 0;
  if (userData?.includes(" reviewResults")) {
    isReviewResults = 1;
  }

  let isConfirmStudy = 0;
  if (userData?.some((item) => item?.trim?.() === Privileges.CONFIRM_STUDY)) {
    isConfirmStudy = 1;
  }

  let isReviewCompliance = 0;
  if (
    userData?.some((item) => item?.trim?.() === Privileges.REVIEW_COMPLIANCE)
  ) {
    isReviewCompliance = 1;
  }

  let isSleepTech = 0;
  if (userData?.some((item) => item?.trim?.() === Privileges.SLEEP_TECH)) {
    isSleepTech = 1;
  }

  let hasSchedulePrivilege = 0;
  if (userData?.some((item) => item?.trim?.() === Privileges.SCHEDULE)) {
    hasSchedulePrivilege = 1;
  }

  let hasViewSchedulePrivilege = 0;
  if (userData?.some((item) => item?.trim?.() === Privileges.VIEW_SCHEDULE)) {
    hasViewSchedulePrivilege = 1;
  }

  //for facility tab
  if (trimmedUserData?.includes("pracGroups")) {
    trimmedUserData.push("facilities");
  }

  //for configuration tab
  if (trimmedUserData?.includes("super")) {
    trimmedUserData.push("configuration");
  }

  trimmedUserData?.push("incomingsms");
  let tabData = tab?.filter((item) => {
    if (trimmedUserData?.includes(item?.tabName)) {
      return item;
    }
  });
  const subtab = subTab?.filter((item) => {
    if (trimmedUserData?.includes(item)) {
      return item;
    }
  });
  const isProfile = tabData?.some((obj) =>
    Object.values(obj).includes("profSettings"),
  );
  if (subtab?.includes("signOrder") && !isProfile) {
    tabData?.push({ tabName: "profSettings", path: "/physician-profile" });
  }
  let roleAndPriviledge = {
    role: roleData,
    privileges: {
      tab: tabData,
      subtab: subtab,
    },
    userName,
    npi,
    isAllPatients,
    isDiscussResults,
    isReviewResults,
    isConfirmStudy,
    isReviewCompliance,
    isSleepTech,
    hasSchedulePrivilege,
    hasViewSchedulePrivilege,
    isPhysician,
    roleId: roleId,
    userInfo,
    isEncryptedInfo,
    isOrderAuthority,
    id,
    tempPassword,
    isSuperAdmin,
    isAdministrator,
    isInsuranceDepartment,
  };
  let tabPath;
  if (tempPassword)
    tabPath = `${
      subtab?.includes("signOrder") ? "/physician-profile" : "/profile"
    }`;
  else tabPath = tabData[0]?.path;

  return {
    tabPath,
    roleAndPriviledge,
    id,
    groupId,
    roleData,
    roleId,
    tempPassword,
    userInfo,
  };
}
